import { FC, ReactNode } from 'react';
import { observer } from 'mobx-react';

import { Button, ButtonGroup, Headline, Layout, Page, Stack } from '@servicetitan/design-system';
import { useDependencies } from '@servicetitan/react-ioc';

import { TermsStore } from '../stores/terms.store';

export const HtmlTermsPage: FC<{ children?: ReactNode }> = observer(({ children }) => {
    const [termsStore] = useDependencies(TermsStore);

    return (
        <Page
            header={<Headline size="large">Terms and Conditions</Headline>}
            footer={
                <Stack className="w-100" justifyContent="flex-end">
                    <ButtonGroup>
                        <Button primary outline onClick={termsStore.handleDecline}>
                            Decline
                        </Button>
                        <Button
                            primary
                            loading={termsStore.accepting}
                            onClick={termsStore.handleAccept}
                        >
                            Accept
                        </Button>
                    </ButtonGroup>
                </Stack>
            }
        >
            <Layout>
                <Layout.Section>{children}</Layout.Section>
            </Layout>
        </Page>
    );
});
HtmlTermsPage.displayName = 'HtmlTermsPage';
